import React from 'react';
import {bool, string, func, arrayOf} from 'prop-types';
import {useLocation} from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import wrap from 'wraptile';

import User from './AppSidebarUser/AppSidebarUserConnected';
import Toggler from './AppSidebarToggler';
import Logo from './AppSidebarLogo';
import AdminLinks from './AppSidebarLinks/AdminLinks/AppSidebarAdminLinks';
import CommonLinks from './AppSidebarLinks/AppSidebarCommonLinks';

export const getClass = (isOpen: any) => {
    return `root__drawer ${
        isOpen ? 'root__drawer_open' : 'root__drawer_close'
    }`;
};

export const handleClick = wrap((handleSidebarClose: any, isOpen: any) => {
    handleSidebarClose(!isOpen);
});

export default function AppSidebar(props: any) {
    const {isOpen, handleSidebarClose, roles} = props;
    const onClick = handleClick(handleSidebarClose, isOpen);
    const drawerClass = getClass(isOpen);
    const drawerClasses = {
        paper: drawerClass,
    };
    const {pathname} = useLocation();
    
    return (
        <Drawer
            variant="permanent"
            className={drawerClass}
            classes={drawerClasses}
        >
            <Box className="root__drawer__inner">
                <List>
                    <ListItem>
                        <Logo isOpen={isOpen} />
                    </ListItem>
                    <CommonLinks path={pathname} />
                    <AdminLinks
                        roles={roles}
                        path={pathname}
                    />
                </List>
                <Box>
                    <User isOpen={isOpen} />
                    <Toggler
                        isOpen={isOpen}
                        onClick={onClick}
                    />
                </Box>
            </Box>
        </Drawer>
    );
}

AppSidebar.propTypes = {
    isOpen: bool.isRequired,
    handleSidebarClose: func.isRequired,
    roles: arrayOf(string).isRequired,
};
